import { Component, OnInit, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, SessionInformationService, UtilityService } from 'app/core/core.module';
import { ValidationCallbackData } from 'devextreme/common';
import { confirm, alert } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import moment from 'moment';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    standalone: true,
    imports: [DevExtremeModule],
})
export class OverviewComponent implements OnInit {
    filter: {
        email: string;
        userCode: string;
    };
    codeFilter: {
        email: string;
        budgetBox: string;
        birthDate: Date;
    };
    dateString: string;
    processing = false;
    validationGroup = 'mainValidation';
    codeFilterOptions: any;

    constructor(
        private utility: UtilityService,
        private appInfo: AppInformationService,
        private router: Router,
        private auth: AuthService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        this.filter = { email: null, userCode: null };
        this.codeFilter = { email: null, budgetBox: null, birthDate: null };
        this.codeFilterOptions = { mask: '99/99/9999' };
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async loginMember() {
        this.appInfo.pleaseWaitShow();
        try {
            const result = await this.auth.getMemberUser(this.filter.email, this.filter.userCode);
            if (result.user) {
                const success = await this.utility.updateMemberPassword();
                this.sessionInfo.setItem('memberEmail', this.filter.email);
                this.sessionInfo.setItem('memberCode', this.filter.userCode);
                this.sessionInfo.setItem('portal', true);
                if (!!success) this.router.navigate(['/home']);
                this.appInfo.pleaseWaitHide();
                return;
            }

            this.appInfo.pleaseWaitHide();
            alert(`Error logging into server as member. ${result.message ? result.message : ''}`, 'Login Error');
        } catch (exception) {
            this.appInfo.pleaseWaitHide();
            alert((exception && (exception.error.error_description || exception.message)) || 'Error logging into server', 'Login Error');
        }
    }
    onDateChanged(e) {}

    validateDateFormat = (e: ValidationCallbackData) => {
        // console.log('e', e);
        // const dateArray = e.value.split('/');
        // console.log('dateArray', dateArray); 
        // if (dateArray.length !== 3) return false;
        // if (dateArray[0].length !== 2 || dateArray[1].length !== 2 || dateArray[2].length !== 4) return false;
        // if (isNaN(Number(dateArray[0])) || isNaN(Number(dateArray[1])) || isNaN(Number(dateArray[2])))
        //     return false;


        // // returns false if string includes decimal, 'e', the '+' or '-' sign, etc.
        // const onlyContainsDigits = /^\d+$/.test(dateArray[0]) && /^\d+$/.test(dateArray[1]) && /^\d+$/.test(dateArray[2]);
        // if (!onlyContainsDigits) return false;
        return true
    };


    async getCode() {
        if (!this.validate()) return;
        if (!this.codeFilter.email || !this.codeFilter.birthDate) {
            await (<Promise<any>>alert(`Fill in the required information`, 'Error'));
            return;
        }
        if (moment(this.codeFilter.birthDate).year() < 1900 && moment(this.codeFilter.birthDate).year() > 35) {
            this.codeFilter.birthDate = new Date(this.codeFilter.birthDate.getFullYear() + 1900, this.codeFilter.birthDate.getMonth(), this.codeFilter.birthDate.getDate());
        }
        if (moment(this.codeFilter.birthDate).year() <= 35) {
            this.codeFilter.birthDate = new Date(this.codeFilter.birthDate.getFullYear() + 2000, this.codeFilter.birthDate.getMonth(), this.codeFilter.birthDate.getDate());
        }
        this.processing = true;
        let result = '';

        try {
            this.appInfo.pleaseWaitShow();
            result = (await this.utility.getMemberCode(this.codeFilter)) as any;
            await (<Promise<any>>alert(`${result}`, 'Graafschap ARK'));
        } catch (error) {
            this.appInfo.pleaseWaitHide();
            this.processing = false;
            await alert('Error: ' + error.message, 'Code Error');
            return;
        }

        this.appInfo.pleaseWaitHide();
        this.processing = false;
        this.codeFilter = { email: null, budgetBox: null, birthDate: null };
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
